import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LoadingIndicator from "../LoadingIndicator";
import { CommonDropDown } from "../../common/Resusable/CommonDropDown";

const PermanentBookingFileDropDown = ({
    fileList,
    setFileName,
    bookingFilter,
    setListPageOpen,
    fileName,
    clearToken,
    isRefreshActive,
    dropDownChangeHandler
}) => {
    //const [selectedFileName, setSelectedFileName] = useState(null)
    const [options, setOptions] = useState([]);
    const { t, i18n } = useTranslation(["labels", "errors"]);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        const options = fileList?.map((el) => ({
            label: el.fileName,
            value: el.fileName,
        }));
        setOptions(options);
    }, [fileList]);

    const handleChange = (e) => {
        clearInterval(clearToken);
        bookingFilter.confirmed = true;
        bookingFilter.queued = true;
        bookingFilter.tobeProcessed = true;
        bookingFilter.failed = true;
        dropDownChangeHandler?.()
        //setSelectedFileName(e.target.value)
        if (isRefreshActive) {
            setLoading(true);
            setTimeout(() => {
                setFileName(e.target.value);
                setLoading(false);
            }, 5100);
        } else {
            setFileName(e.target.value);
        }
    };

    return (
        <>
            {isLoading ? <LoadingIndicator /> : ""}
            <CommonDropDown
                id="permanent-booking-file-select-dropdown-id"
                value={fileName}
                options={options}
                onChange={(e) => {
                    handleChange(e);
                    setListPageOpen(true);
                }}
                label={t("PERMANENT_BOOKING.SELECT_TMPLTE")}
            />
        </>
    );
};

export default PermanentBookingFileDropDown;
